import Typography from '../Typography/Typography';
import Box from 'component/layoutComponents/Box/Box';
import styled from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';

export const StyledOrderRequest = styled(Box)(({ theme }: {theme: typeof DefaultUptimeTheme}) => `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  padding-top: ${theme.uptimeSpace[8]}px;
  background-color: ${theme.uptimeColors.grayScales.grayish};

  & > * {
    padding: 16px;
  }

  @media screen and (min-width: ${theme.breakpoints.md}) {
    min-height: unset;
    padding: ${theme.uptimeSpace[4]}px 0;
    background: ${theme.uptimeColors.mainTheme.background};
    border-radius: 16px;

    & > * {
      padding: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[16]}px;
    }
  }
`);

export const StyledTitle = styled(Box)(({ theme }) => `
  display: flex;
  align-items: center;
`);

export const StyleStartRequestButton = styled(Box)(({ theme }) => `
  position: fixed;
  bottom: ${theme.uptimeSpace[12]}px;

  button.MuiButton-contained {
    padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[8]}px;
    border-radius: 64px;
  }
`);

export const StyledCloseIcon = styled(Box)`
  ${({ theme }) => `
    display: none;
    @media screen and (max-width: ${theme.breakpoints.md}) {
      display: flex;
      align-items: center;
      padding: 0 ${theme.uptimeSpace[8]}px;
      margin-right: 12px;
    }
  `}
`;

export const StyledTerm = styled(Typography)`
  ${({ theme } : {theme: typeof DefaultUptimeTheme}) => `
    order: 2;
    color: ${theme.uptimeColors.textColors.secondary} !important;
    display: inline;
    line-height: ${theme.uptimeLineHeights.desktop.lh4}px !important;

    @media screen and (min-width: ${theme.breakpoints.md}) {
      order: 4;
    }
  `}
`;

export const StyledDetailAddress = styled(Typography)`
  ${({ theme }) => `
    line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
  `}
`;

export const StyledDescription = styled(Typography)`
  ${({ theme }) => `
    margin: ${theme.uptimeSpace[10]}px 0 ${theme.uptimeSpace[16]}px 0 !important;
  `}
`;

export const StyledApprovalForm = styled(Box)`
  ${({ theme }: {theme: typeof DefaultUptimeTheme}) => `
    display: flex;
    align-items: center;
    color: ${theme.uptimeColors.textColors.secondary};

    .MuiAvatar-root {
      margin-right: ${theme.uptimeSpace[8]}px;
      background-color: ${theme.uptimeColors.grayScales.gray};
      font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
    }
  `}
`;

export const StyledButtonSubmit = styled(Box)`
  ${({ theme }: {theme: typeof DefaultUptimeTheme}) => `
    order: 3;
    background: ${theme.uptimeColors.grayScales.white};
    box-shadow: 0px 8px 10px -5px ${theme.uptimeColors.grayScales.gray}, 0px 16px 24px 2px rgba(0, 0, 0, 0.14),
      0px 6px 30px 5px ${theme.uptimeColors.grayScales.grayish};

    @media screen and (min-width: ${theme.breakpoints.md}) {
      margin-top: auto;
      padding-bottom: 0;
      background-color: unset;
      box-shadow: none;
    }
  `}
`;

